import CitySelectPresenter from "../components/city-select/presenter/city-select";

const buttonElement = document.querySelector(`.city-select-button`);

if (buttonElement) {
  const citySelectComponent = new CitySelectPresenter(buttonElement);
  citySelectComponent.init();
}
